import React from "react";
import s from "@/components/Footer/Footer.module.scss";
import cn from "@/utils/classNames.js";
import { useTemplateStore } from "@/zustand/templateStore.js";

const Footer = () => {
  const footerLinks = window.post_template.checkout_v6_footer.footer_links;
  const isEnhancedContrast = useTemplateStore((state) => state.enhancedContrast);

  return (
    <div className={cn(s.simpleFooter, isEnhancedContrast && s.enhancedContrast)}>
      <div className={s.simpleFooter__links}>
        {Array.isArray(footerLinks) &&
          footerLinks.map((link, index) => {
            return (
              <a
                key={index}
                href={
                  !link.footer_link_type
                    ? link.footer_custom_link.footer_custom_link_href
                    : link.footer_post_link.footer_post_link_href
                }
                className={cn(isEnhancedContrast && s.enhancedContrast)}
              >
                {!link.footer_link_type
                  ? link.footer_custom_link.tr_footer_custom_link_label
                  : link.footer_post_link.tr_footer_post_link_label}
              </a>
            );
          })}
      </div>
    </div>
  );
};

export default Footer;
